<div class="bz-shadow--s">
  <div class="bz-space--inset-l">
    <div class="bz-font-size--body-small bz-font-weight--semibold bz-space--stack-m bmc-jobs-filter__header">
      {{'GLOBAL.SHOW_HIDE' | translate}}
      <a (click)="close()">
        <svg _ngcontent-c76="" class="bmc-jobs-filter__close"><use _ngcontent-c76="" href="#icon-close"></use></svg>
      </a>
    </div>
    <ul class="bmc-jobs-filter__list">
      <li *ngFor="let col of columnsToFilter" class="bz-space--stack-m bz-space--inline-xl">
        <bzg-checkbox [disabled]="col.blocked" [checked]="col.visible" (change)="change(col, $event)">
          {{ col.value | translate}}
        </bzg-checkbox>
      </li>
    </ul>
  </div>
  <div class="bmc-jobs-filter__footer bz-space--inset-m bz-color-border--neutral-200">
    <bzg-button-secondary class="bz-space--inline-m" (click)="clearAll()">
      {{'GLOBAL.CLEAR_ALL' | translate}}
    </bzg-button-secondary>
    <bzg-button-primary class="bz-space--inline-m" (click)="apply()">
      {{'GLOBAL.APPLY' | translate}}
    </bzg-button-primary>

  </div>
</div>
